import React from 'react';
import './TradeOrderForm.scss';
import { useParams } from 'react-router-dom';
import { TradeOrderDetailTable } from '@widgets/TradeOrderDetailTable';

export const TradeOrderForm: React.FC = () => {
    const { orderId } = useParams<{ orderId: string }>();
    return (
        <div className='margin-20-top-div'>
            <div className='top-header-trade-form'>
                <div className='bold-text-dashboard'>Trade Orders /</div>
                <div className='grey-text-dashboard'> Details</div>
            </div>
            <div className='trade-order-table'>
                <TradeOrderDetailTable orderId={orderId ? orderId : 0} />
            </div>
        </div>
    );
};
